const errorHandling = {
    state: () => ({
        message: '',
        code: 0
    }),
    getters: {
        getErrorMessage: state => state.message,
        isError: state => !!state.message
    },
    mutations: {
        setErrorMessage(state, payload) {
            state.message = payload;
        },
        reset(state) {
            state.message = "";
        }
    },
    actions: {
        resetErrors({commit}) {
            commit("reset");
        },
        setError({commit}, error) {
            commit("setErrorMessage", error.data.message);
        }
    }
};
export default errorHandling;
